
import '../music.css';
import { Form, Input, InputNumber, Button, Layout, Row, Col,Upload,notification, message,Modal, Checkbox, Select,ConfigProvider, Divider, Collapse, Card, Menu    } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../static/img/Cabezal.jpg'
import { UploadOutlined,CheckOutlined, HomeOutlined,FileTextOutlined, MinusCircleOutlined, EyeInvisibleOutlined, EyeTwoTone, LockOutlined,MailOutlined, UserOutlined, LogoutOutlined} from '@ant-design/icons';
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import Navbar from '../components/NavBar' 

class App extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      authors:[],
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/composicion/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  async componentDidMount() {
    const response = await fetch('https://back.premiocasa.cult.cu/api/composicion/genero/');
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    this.setState({ genres: json });
  }

  addAuthor = () =>{

  }
   async logout(){
      await fetch('https://back.premiocasa.cult.cu/api/logout',{
        method: "post",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"
      },
      }).then(result=>{
        if(result.status == 200){
          var userId = localStorage.getItem("UserId")
          const data_log= new FormData()
          data_log.append('usuario',userId)
          data_log.append('accion',"Salida del sistema")
        
          axios.post('https://back.premiocasa.cult.cu/api/casa/logs/', data_log)
          localStorage.clear()
          window.location.reload(); 
        }
        else{
          notification.error({
        message:'Error',
        description:'Hubo un error, por favor intente más tarde',
      })}
      })
    }

  render() {
    
    const layout = {
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },

    }
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginLeft:'203px'
    };

    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          offset: 1,
        },
        sm: {
          span: 4,
          offset: 8,
        },
      },
    };
    
    const validateMessages = {
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    function addAuthors(formdata, users, name) {
      for (var i = 0; i < users.length; i++) {
        addSingleAuthor(formdata, users[i], name + "[" + i + "]");
      }
  }
  
  function addSingleAuthor(formdata, user, name) {
      for (var key in user) {
          formdata.append(name + "." + key,  user[key]);
      }
  }
      
    const customRequest = (form) => {
     
      const data= new FormData()
      console.log(form)
      for(var aut in  form['autores']){
        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel']
        console.log(form['autores'][aut]['tel'])

      }

    //   form
    //   console.log(form['pdf'].fileList[0])
      form['pdf'] =  form['pdf'].fileList[0]["originFileObj"]
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
          // addAuthors(data,form[key],'autores')
        }
        else{
          data.append(key, form[key]);
        }
    }

  //   for (var value of data.values()) {
  //     console.log(value);
  //  }
      axios.post('https://back.premiocasa.cult.cu/api/PremioCasa2022/obra/register/', data).then((res) => {
        if (res.status == 200){
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
          });
        } ;
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise sus datos',
        });
      })
  }
    
    const checkBoxChange = e =>{
      console.log(e.target.checked)
      this.setState({showRegistrate:e.target.checked})
    }
    const handlesubmit = (values) =>{
      console.log(values)
        axios.post(
          'https://back.premiocasa.cult.cu/api/composicion/obra/',{
          data:values
        }).then((res) => {
          console.log(res)
              if (res.status == 200) {
                notification.success("data successfully updated!");
              }
              else{
                notification.error({
                  message:'Error',
                  description:'Ter was an error',
                  
                });
              }
            })
            .catch((err) => {
              
              console.log(err)
            });
    }
      const onFinish = (values) => {
        console.log(values);
      }
      const { Header, Footer, Content } = Layout;
      const { Option } = Select;
      const { fileList } = this.state;
      const props = {
        onRemove: file => {
          this.setState(state => {
            const index = this.state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList,
            };
          });
        },
        beforeUpload: file => {
          this.setState({
            fileList: [file],
          });
          return false;
        },
        fileList,
      };
      const { Panel } = Collapse;
      const autores = <div>
        
          </div>
        const menu = (
          <Menu style={{height:'140'}} mode="inline">
                <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/composicion/admin"> Home</NavLink>
                </Menu.Item>
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/composicion/admin_plays_list"> Obras</NavLink>
                </Menu.Item>
                <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/composicion/admin_conc_list'> Concursantes  </NavLink>
                </Menu.Item>  
          <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
          <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
          </Menu.Item>
          
          </Menu>
        )
    return (

      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/composicion/admin"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Navbar menu = {menu}/>
            
            </Col>
          </Row>
          <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
          
         
          <Row >
            <Col span={24} >
            <Content style={{ padding: '0 50px' }}>
            <Card title=" Bases Premio de Musicología Casa de las Américas " bordered={false}  >
         
         <p>La Casa de las Américas convoca a todos los interesados a participar en la decimoctava edición del Premio de Musicología Casa de las Américas, que de manera excepcional se realizará en modalidad virtual. 

<ol style={{paddingLeft:'1.8em'}}>
  <li>Podrán participar autores latinoamericanos y caribeños, naturales o naturalizados, con libros que contribuyan a una comprensión más integral de la música y la cultura de la América Latina y del Caribe, a partir de los diversos conceptos y procedimientos de las ciencias sociales contemporáneas. </li>
  <li>Concursarán textos inéditos sobre: historiografía musical; interpretación y explicación crítica de la creación musical; música tradicional y folclórica; teoría y práctica de la enseñanza de la música; marcos teóricos globales de la musicología; y otros problemas relacionados con la estética, la sociología y la antropología de la música, entre otros. </li>
  <li>Las obras se considerarán inéditas, aunque hayan sido publicadas hasta dos tercios de las mismas. </li>
  <li>Ningún autor podrá participar con una obra que haya obtenido algún premio nacional o internacional. </li>
  <li>Se otorgará un premio único e indivisible. El premio consistirá en tres mil dólares o su equivalente en la moneda nacional que corresponda y la publicación de la obra por la Casa de las Américas. Se otorgarán menciones si el jurado lo estima necesario, sin que ello implique ningún compromiso editorial ni retribución por parte de la Casa de las Américas.</li>
  <li>La Casa de las Américas se reserva el derecho de publicación de la que será considerada primera edición de la obra premiada, que tendrá hasta un máximo de mil ejemplares, aunque se trate de una coedición. Tal derecho incluye no sólo evidentes cuestiones económicas, sino todas las características gráficas y otros aspectos de la mencionada primera edición. En las sucesivas ediciones los derechos corresponderán íntegramente al autor. </li>
  <li>La Casa de las Américas tendrá la primera opción sobre la obra premiada y las mencionadas durante un año, a efectos de negociar su publicación en todo el mundo. Los derechos de toda contratación se revertirán sobre el autor, descontándose en cada caso un 10% que será para la Casa de las Américas. </li>
  <li>Los autores deberán enviar sus obras de manera digital accediendo a Premio de Musicología Casa de las Américas en la plataforma  <a  target="_blank" href="https://premiocasa.cu/composicion">https://premiocasa.cu/composicion</a> que estará disponible a partir del 1 de septiembre de 2021.</li>
  <li>Las obras podrán tener hasta un máximo de 500 páginas en letra Times New Roman 12, a dos espacios y foliadas, que se enviarán en documento cerrado en PDF. En caso de llevar ejemplos musicales o audiovisuales, se deben enviar en carpeta aparte, numerados y con la debida indicación de las fuentes de referencia o archivos donde se encuentran los documentos originales. Los documentos serán enviados en un archivo comprimido .zip .</li>
  <li>Si la obra no corresponde a un autor de lengua castellana, el texto se enviará en el idioma original y una traducción que hará constar el nombre del traductor.</li>
  <li>Es admisible el uso de seudónimo si así lo prefiere el autor. En ese caso, es indispensable acompañar su identificación en documento aparte.</li>
  <li>Cada autor deberá enviar un currículum breve que indique lugar y fecha de nacimiento, títulos o grados, publicaciones recientes, investigaciones en curso, cargos académicos y membresías.</li>
  <li>El plazo de admisión cerrará el viernes 11 de febrero de 2022, a las 12 de noche, hora de La Habana. </li>
  <li>El jurado quedará constituido oficialmente en marzo de 2022.</li>
  <li>La premiación tendrá lugar el viernes 11 de marzo de 2022 y el dictamen del jurado será inapelable. </li>
  <li>Los autores que contravengan lo especificado en estas bases serán descalificados. El envío de la obra presupone e implica la aceptación íntegra de estas bases.</li>
  <li>Los autores interesados podrán comunicarse con la Dirección de Música de la institución a través de la dirección electrónica <a href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a> .</li>
</ol> 
 

            </p>
            
         </Card>
          </Content>
              
              </Col>
          </Row>
   </div>
          
         


          </Layout>
        </ConfigProvider>
        </div>
        <div >
          <Footer style={{backgroundColor:'#fac14e', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#fac14e',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/composicion/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/composicion/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
        </div>
    </div>

    );
  }
}
export default App;


